import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { createStructuredSelector } from 'reselect';
import { injectIntl } from 'react-intl';
import { withRouter } from 'react-router-dom';
import { hot } from 'react-hot-loader';
import { compose } from 'ramda';

import { TimeSlots } from './timeSlots.component';
import { selectBookingTimeslots, BookingActions, selectBookingSlots } from '../../../../modules/booking';

const mapStateToProps = createStructuredSelector({
  activeSlots: selectBookingSlots,
  slots: selectBookingTimeslots,
});

export const mapDispatchToProps = dispatch =>
  bindActionCreators(
    {
      onSlotSelected: BookingActions.selectSlot,
      onSlotUnselected: BookingActions.unselectSlot,
    },
    dispatch
  );

export default compose(
  hot(module),
  connect(
    mapStateToProps,
    mapDispatchToProps
  ),
  injectIntl,
  withRouter
)(TimeSlots);
